import { useEffect, useState } from 'react';
import { Alert } from '@mui/material';
import { useApiClient } from '../ApiClientProvider';
import { SystemService } from '../services/systemService';

// Re-checked on an interval so a message set in Azure App Service configuration appears
// without requiring visitors to reload the app.
const REFRESH_INTERVAL_MS = 5 * 60 * 1000;

export default function SystemBanner() {
    const apiClient = useApiClient('applicationClient');
    const [message, setMessage] = useState<string | null>(null);

    useEffect(() => {
        const systemService = new SystemService(apiClient);
        let cancelled = false;

        const loadBanner = async () => {
            try {
                const banner = await systemService.getBanner();
                if (!cancelled) {
                    setMessage(banner.message);
                }
            } catch {
                // A failed banner fetch should never block the rest of the app from loading.
                if (!cancelled) {
                    setMessage(null);
                }
            }
        };

        void loadBanner();
        const interval = setInterval(loadBanner, REFRESH_INTERVAL_MS);

        return () => {
            cancelled = true;
            clearInterval(interval);
        };
    }, [apiClient]);

    if (!message) {
        return null;
    }

    return (
        <Alert
            severity="warning"
            variant="filled"
            sx={{
                borderRadius: 0,
                justifyContent: 'center',
                textAlign: 'center',
                '& .MuiAlert-message': {
                    overflow: 'visible',
                    whiteSpace: 'normal',
                    overflowWrap: 'anywhere',
                },
            }}
        >
            {message}
        </Alert>
    );
}
